import BasicLayout from '../../layouts/BasicLayout'
import PortfolioImageList from '../../components/user/PortfolioImageList'
import SubTitle from '../../components/user/SubTitle'
import MetaTag from '../../components/user/MetaTag'

function PortfolioPage() {
    return (
        <BasicLayout>
            <div className="mx-auto px-4 py-8">
                <MetaTag
                    title="인테리어 리모델링 포트폴리오 | 더룸 시공 사례 모음"
                    description="더룸의 실제 인테리어 리모델링 포트폴리오를 모았습니다. 공간별 시공 사례를 한 번에 둘러보세요."
                    imgsrc="https://www.theroom.co.kr/assets/logos/og-image.png"
                    url="https://www.theroom.co.kr/portfolio"
                />
                <SubTitle content={"PORTFOLIO"} />
                <PortfolioImageList />
            </div>
        </BasicLayout>
    )
}

export default PortfolioPage